import {fork, put, select, take} from 'redux-saga/effects';
import {persistenceStates} from '@computerrock/formation-core';
import fetchRequest from '../../application/sagas/fetchRequest';
import * as taskActionTypes from '../taskActionTypes';

const searchTasks = function* searchTasks({payload}) {
    const {serviceManager} = yield select(state => state.application);
    const ecsTaskManagementService = serviceManager.loadService('ecsTaskManagementService');
    const {searchQueryParams} = payload;

    yield put({
        type: taskActionTypes.STORE_TASK_SEARCH_RESULTS,
        payload: {
            taskDTOs: [],
            taskSearchResultsCount: 0,
            persistenceState: persistenceStates.PENDING,
            isError: false,
        },
    });

    yield fork(
        fetchRequest,
        taskActionTypes.SEARCH_TASKS_REQUEST,
        ecsTaskManagementService.getTasks, {
            searchQueryParams,
        },
    );

    const responseAction = yield take([
        taskActionTypes.SEARCH_TASKS_REQUEST_FAILED,
        taskActionTypes.SEARCH_TASKS_REQUEST_SUCCEEDED,
    ]);

    if (!responseAction.error) {
        const {response} = responseAction.payload;
        const {taskDTOs, totalCount: taskSearchResultsCount} = response;

        yield put({
            type: taskActionTypes.STORE_TASK_SEARCH_RESULTS,
            payload: {
                taskDTOs,
                taskSearchResultsCount,
                persistenceState: persistenceStates.READY,
                isError: false,
            },
        });
    }
    if (responseAction.error) {
        yield put({
            type: taskActionTypes.STORE_TASK_SEARCH_RESULTS,
            payload: {
                taskDTOs: [],
                taskSearchResultsCount: 0,
                persistenceState: persistenceStates.READY,
                isError: true,
            },
        });
    }
};

export default searchTasks;
